<template>
    <v-row dense cols="12">
        <v-col cols="3" class="pr-2">{{ headers.header_role }}</v-col>
        <v-col cols="5" class="pr-2">{{ headers.header_eign }}</v-col>
        <v-col cols="4">{{ headers.header_vat }}</v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            huov_encrid: String
        },
        data() {
            return {     
                headers: {},           
            }
        },
        created() {
            this.getHeaders();
        },
        methods: {
            getHeaders(){
                this.$axios
                    .post("ares/json/ares/huov/hokl/getOwnerHeader.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getOwnerHeader"
                        },
                        getOwnerHeader: {
                            huov_encrid: this.huov_encrid,
                        }                        
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error.message);
                        } else {
                            this.headers = res.data.getOwnerHeader;
                        }
                    })
            },
        }
    }

</script>

<style scoped>

</style>